export const heroStats = [
  { label: '最新版本', value: 'v5.8.2' },
  { label: '安装包大小', value: '78.4 MB' },
  { label: '系统要求', value: 'Android 8.0+' },
  { label: '更新时间', value: '2026-10-08' },
];

export const downloadEntries = [
  {
    id: 'android',
    icon: 'ri-android-line',
    tone: 'primary',
    title: '安卓版下载',
    subtitle: 'Android APK 官方安装包',
    meta: ['适配主流安卓机型', '含完整资源文件'],
    cta: '下载安卓版',
  },
  {
    id: 'mobile',
    icon: 'ri-smartphone-line',
    tone: 'accent',
    title: '手机版入口',
    subtitle: '免安装直接在浏览器打开',
    meta: ['无需下载安装包', '适配手机浏览器'],
    cta: '打开手机版',
  },
  {
    id: 'package',
    icon: 'ri-file-zip-line',
    tone: 'secondary',
    title: '完整安装包',
    subtitle: 'APK 与数据包合集',
    meta: ['一次下载一步到位', '适合重装或换机'],
    cta: '获取安装包',
  },
  {
    id: 'latest',
    icon: 'ri-refresh-line',
    tone: 'foreground',
    title: '最新版本',
    subtitle: 'v5.8.2 正式版',
    meta: ['更新于 2026-10-08', '修复已知问题'],
    cta: '查看更新',
  },
];

export const versionRows = [
  { label: '版本号', value: 'v5.8.2（正式版）' },
  { label: '更新时间', value: '2026-10-08' },
  { label: '安装包大小', value: '78.4 MB' },
  { label: '系统要求', value: 'Android 8.0 及以上' },
  { label: '安装包格式', value: 'APK' },
  { label: '文件校验', value: 'MD5 a3f1 · 9c2e · 7b40' },
];

export const changelog = [
  '优化视频播放加载速度，起播更顺畅',
  '修复部分机型安装后首次打开闪退问题',
  '新增批量收藏与稍后再看列表',
  '调整下载中心入口位置，更容易找到',
  '适配更多安卓机型与高刷屏显示',
];

export const installSteps = [
  {
    step: '01',
    icon: 'ri-settings-3-line',
    title: '开启安装权限',
    desc: '进入手机设置，开启「允许安装未知来源应用」，否则安装包无法点击运行。',
  },
  {
    step: '02',
    icon: 'ri-download-cloud-2-line',
    title: '获取安装包',
    desc: '在本页选择对应安卓版下载入口，等待 APK 文件下载完成，勿中途关闭页面。',
  },
  {
    step: '03',
    icon: 'ri-install-line',
    title: '完成安装',
    desc: '点击下载好的安装包，按系统提示一路确认，几秒后即可完成安装。',
  },
  {
    step: '04',
    icon: 'ri-play-circle-line',
    title: '打开并授权',
    desc: '首次启动授予存储权限，即可正常播放与缓存，建议加入桌面快捷方式。',
  },
  {
    step: '05',
    icon: 'ri-loop-right-line',
    title: '保持最新版',
    desc: '在应用内「设置 → 检查更新」获取最新版本，避免旧版本安装入口失效。',
  },
];

export const topicTags = [
  { text: '安卓版下载', tone: 'primary', size: 'lg' },
  { text: '安装包', tone: 'accent', size: 'md' },
  { text: '最新版本', tone: 'secondary', size: 'md' },
  { text: '手机版入口', tone: 'primary', size: 'md' },
  { text: '安装教程', tone: 'secondary', size: 'sm' },
  { text: '更新失败怎么办', tone: 'accent', size: 'sm' },
  { text: 'APK 解析失败', tone: 'primary', size: 'sm' },
  { text: '官方入口辨别', tone: 'secondary', size: 'md' },
  { text: '换机迁移', tone: 'accent', size: 'sm' },
  { text: '存储权限', tone: 'primary', size: 'sm' },
  { text: '苹果手机怎么用', tone: 'secondary', size: 'sm' },
  { text: '安装包多大', tone: 'accent', size: 'sm' },
];

export const hotRanking = [
  {
    rank: 1,
    title: '安卓版安装包下载教程',
    tag: '下载',
    heat: 9840,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20orange%20abstract%20video%20play%20button%20graphic%20on%20a%20soft%20cream%20background%2C%20minimalist%20flat%20cover%20art%20with%20gentle%20gradient%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20harmonious%20composition&width=240&height=240&seq=rank-cover-01&orientation=squarish',
  },
  {
    rank: 2,
    title: '手机版免安装入口在哪',
    tag: '手机版',
    heat: 8712,
    cover:
      'https://readdy.ai/api/search-image?query=Fresh%20leaf%20green%20abstract%20smartphone%20outline%20graphic%20on%20a%20warm%20cream%20background%2C%20minimalist%20flat%20cover%20art%2C%20soft%20gradient%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20clean%20composition&width=240&height=240&seq=rank-cover-02&orientation=squarish',
  },
  {
    rank: 3,
    title: '更新失败与闪退怎么解决',
    tag: '排错',
    heat: 7935,
    cover:
      'https://readdy.ai/api/search-image?query=Golden%20amber%20abstract%20refresh%20arrow%20graphic%20on%20a%20soft%20cream%20background%2C%20minimalist%20flat%20cover%20art%20with%20warm%20gradient%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20balanced%20composition&width=240&height=240&seq=rank-cover-03&orientation=squarish',
  },
  {
    rank: 4,
    title: '最新版本号与原版区别',
    tag: '版本',
    heat: 6621,
    cover:
      'https://readdy.ai/api/search-image?query=Deep%20terracotta%20orange%20abstract%20number%20badge%20graphic%20on%20a%20warm%20cream%20background%2C%20minimalist%20flat%20cover%20art%2C%20soft%20shading%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20clean%20composition&width=240&height=240&seq=rank-cover-04&orientation=squarish',
  },
  {
    rank: 5,
    title: 'APK 解析失败提示怎么办',
    tag: '排错',
    heat: 5478,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20red%20orange%20abstract%20file%20folder%20graphic%20on%20a%20soft%20cream%20background%2C%20minimalist%20flat%20cover%20art%20with%20gentle%20gradient%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20harmonious%20composition&width=240&height=240&seq=rank-cover-05&orientation=squarish',
  },
  {
    rank: 6,
    title: '官方下载入口怎么辨别',
    tag: '指南',
    heat: 4203,
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20brown%20abstract%20shield%20check%20graphic%20on%20a%20warm%20cream%20background%2C%20minimalist%20flat%20cover%20art%2C%20muted%20gradient%2C%20editorial%20thumbnail%20style%2C%20high%20detail%2C%20clean%20composition&width=240&height=240&seq=rank-cover-06&orientation=squarish',
  },
];

export const guideArticles = [
  {
    tag: '入门',
    title: '第一次安装蘑菇视频：从下载到打开只需四步',
    excerpt: '把安卓版安装包下载好、开启权限、点击安装、授予存储权限，完整走一遍流程。',
    date: '2026-10-08',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cream%20desk%20scene%20with%20a%20smartphone%20showing%20a%20video%20app%20install%20screen%2C%20soft%20natural%20light%2C%20orange%20and%20amber%20accents%2C%20minimalist%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=500&seq=guide-cover-01&orientation=landscape',
  },
  {
    tag: '教程',
    title: '安卓版下载全流程：安装包怎么选、怎么装',
    excerpt: '普通机型选标准 APK，老旧机型选兼容安装包，避免下错导致无法安装。',
    date: '2026-10-06',
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20android%20phone%20with%20download%20progress%20bar%20on%20a%20warm%20cream%20surface%2C%20soft%20daylight%2C%20orange%20highlight%20details%2C%20minimalist%20editorial%20product%20photography%2C%20high%20detail%2C%20clean%20composition&width=800&height=500&seq=guide-cover-02&orientation=landscape',
  },
  {
    tag: '手机版',
    title: '不想装包？手机版入口直接打开就能看',
    excerpt: '适合临时使用或存储紧张的用户，浏览器打开手机版即可，无需占用安装空间。',
    date: '2026-10-04',
    cover:
      'https://readdy.ai/api/search-image?query=Hand%20holding%20a%20smartphone%20browsing%20a%20video%20site%20on%20a%20warm%20cream%20background%2C%20soft%20lighting%2C%20amber%20warm%20tones%2C%20minimalist%20editorial%20photography%2C%20airy%20composition%2C%20high%20detail&width=800&height=500&seq=guide-cover-03&orientation=landscape',
  },
  {
    tag: '排错',
    title: '安装失败、闪退、解析失败：常见原因对照',
    excerpt: '九成问题来自安装权限与安装包不完整，对照清单逐一排查即可解决。',
    date: '2026-10-02',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20error%20warning%20icon%20on%20a%20soft%20cream%20panel%2C%20minimalist%20flat%20editorial%20graphic%2C%20subtle%20gradient%2C%20high%20detail%2C%20balanced%20composition&width=800&height=500&seq=guide-cover-04&orientation=landscape',
  },
  {
    tag: '版本',
    title: '最新版本值不值得更新？更新前先看这三点',
    excerpt: '新版优化了起播速度与稳定性，老版本可能出现入口失效，建议保持最新。',
    date: '2026-09-29',
    cover:
      'https://readdy.ai/api/search-image?query=Touch%20screen%20smartphone%20with%20update%20version%20prompt%20on%20a%20warm%20cream%20desk%2C%20soft%20side%20light%2C%20orange%20and%20amber%20accents%2C%20minimalist%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=guide-cover-05&orientation=landscape',
  },
  {
    tag: '指南',
    title: '怎么辨别官方下载入口，避开山寨安装包',
    excerpt: '认准本页提供的下载入口与文件校验信息，不要随意点开来路不明的安装包。',
    date: '2026-09-26',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cream%20scene%20with%20a%20shield%20verify%20badge%20next%20to%20a%20smartphone%2C%20soft%20natural%20light%2C%20orange%20warm%20tones%2C%20minimalist%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=500&seq=guide-cover-06&orientation=landscape',
  },
];

export const faqList = [
  {
    q: '蘑菇视频 APP 下载到底怎么弄？',
    a: '在本页选择「安卓版下载」入口获取 APK 安装包，下载完成后点击安装包并按提示确认，最后授予存储权限即可正常使用，全程约一两分钟。',
  },
  {
    q: '找不到安装入口怎么办？',
    a: '多数情况是旧版本入口失效或下载页跳转异常。请回到本页重新获取最新版本安装包，安装完成后在应用内「设置 → 检查更新」保持为最新版。',
  },
  {
    q: '手机版和安卓版有什么区别？',
    a: '手机版无需安装、直接在浏览器打开，适合临时使用；安卓版是完整安装包，功能更全、播放更稳定，适合长期使用。',
  },
  {
    q: '安装包多大，会不会很占空间？',
    a: '当前最新版本安装包约 78.4 MB，安装占用空间会随缓存增长，建议预留约 500 MB 存储空间以保证播放与缓存顺畅。',
  },
  {
    q: '提示「解析安装包出现问题」是什么原因？',
    a: '通常是安装包下载不完整或系统版本过低。请删除已下载文件后重新下载，并确认手机系统为 Android 8.0 及以上。',
  },
  {
    q: '苹果手机可以用吗？',
    a: 'iOS 用户可先使用手机版浏览器入口进行浏览。如需完整客户端，请在应用内查看当前支持的获取方式说明。',
  },
];